import React from "react";
import { useLocation } from "react-router-dom";
import TableTitle from "src/components/home/TableTitle";
import SwipeButton from "src/components/button/SwipeButton";
import PostTable from "src/components/table/PostTable";
import MoreButton from "src/components/button/MoreButton";
import MoreButton2 from "../button/MoreButton2";


interface PostBoardProps <T = {}> {
  contents: T[];
  isMore: boolean;
  handleLoadMore: () => Promise<void>;
}


const PostBoard: React.FC<PostBoardProps> = ({ contents, isMore, handleLoadMore }) => {
  const location = useLocation();
  const isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent);
  
  return (
    <div className={`w-100 py-4 col-12 col-lg ${isMobile?"":"px-3"}`}>
      <TableTitle 
        name="인기 게시글"
        modalData={{
          title: "인기 게시글",
          content: [
            "열람율: 조회수/채널회원수",
            "조회수(실시간): 8~17시, 1시간 단위로 누적 조회",
            "조회수(당일누적): 당일 조회수가 가장 높은 게시글 순"
          ]
        }} 
        tabs={["실시간", "당일누적"]}
        type="/post"
        />
      <hr className="fullscreen-hr" />
      <SwipeButton type="/post" />
      {/* {SelectedCategory && <FilterButtons />} */}
      <PostTable 
        contents={contents}
      />
      {location.pathname === "/" ?<MoreButton path="/post" /> : isMore && <MoreButton2 onClick={handleLoadMore} />}
    </div>
  );
};

export default PostBoard;




